export const Background = () => {
  return (
    // <div className="background">
    //   {Array.from({ length: 46 }).map((_, i) => (
    //     <span key={i}></span>
    //   ))}
    // </div>
    <div className='fixed inset-0 bg-gray-100'></div>
  )
}
